import { createContext, FC, useState } from 'react';

type SetValue = (value: string) => void;

interface TabContextType {
  tabId: string;
  setTabId: SetValue;
}

export const TabContext = createContext<TabContextType>({
  tabId: 'tabCompareAtt',
  setTabId: () => {}
});

export const TabContextProvider: FC = (props) => {
  const [tabId, setTabId] = useState<string>('tabCompareAtt');
  return (
    <TabContext.Provider value={{ tabId, setTabId }}>
      {props.children}
    </TabContext.Provider>
  );
};
